// src/components/admin/qtl - referential/issuers/table.tsx

import { useLocation } from "react-router";
import { Table } from "../../features/Table";
import { type Issuer, issuers_columns } from "./columns";
import { FilterIssuers } from "./filter";

const client = "instit-quantilia";
const table_name = "issuers";

export const IssuersTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Issuer, Issuer>
      label="Issuers"
      client={client}
      table_name={table_name}
      columns={issuers_columns}
      filter={<FilterIssuers />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
